module.exports = __webpack_public_path__ + "static/img/newStyle.c29ffc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newStyle.png
// module id = 7F2N
// module chunks = 29